<p-blockUI [blocked]="loading === true" />
@if (!embedded() && !this._deviceService.isMobile()) {
  <div class="top-section">
    <app-business-unit-filter
      (selectedBusinessUnitsChanged)="handleBusinessUnitChange()"
      class="margin-right"
      #buFilter
    />
    <div class="switch margin-right">
      <label
        >{{ 'CONTACT.LABEL.ADDITIONAL_RESOURCE_LISTS' | translate }}:</label
      >
      <p-toggleswitch
        name="showAdditionalResourceLists"
        class="hide-arls-switch"
        [(ngModel)]="showAdditionalResourceLists"
        (onChange)="refresh()"
      />
    </div>
    @if (canCreate()) {
      <button
        pButton
        label="{{ 'COMMON.LABEL.BUTTONS.NEW' | translate }}"
        icon="fa fa-fw fa-plus"
        class="margin-right"
        (click)="newContactList()"
      ></button>
    }
    <button
      pButton
      class="width-eighty margin-right"
      label="{{ 'COMMON.LABEL.BUTTONS.CLEAR' | translate }}"
      icon="fa fa-fw fa-eraser"
      (click)="clearTable()"
    ></button>
    <button
      pButton
      class="refresh-button width-twenty"
      icon="fa fa-fw fa-refresh"
      (click)="refresh()"
    ></button>
  </div>
}
@if (this._deviceService.isMobile()) {
  <p-panel
    [showHeader]="true"
    header="Filters"
    [toggleable]="true"
    [(collapsed)]="mobileFilterCollapsed"
  >
    <div>
      <div>
        <app-contact-list-mobile-filter
          (mobileFilterEvent)="mobileFilter($event)"
          [showMobileFilter]="true"
        />
      </div>
    </div>
  </p-panel>
}

<app-progress-spinner [enabled]="!elements" />
<div [style.display]="!elements ? 'none' : ''">
  <app-general-grid
    [values]="elements"
    [columns]="columns"
    [loading]="loading"
    [rows]="rows"
    [totalRecords]="totalRecords"
    [filterable]="true"
    [screenName]="screenName"
    [lazy]="true"
    (lazyLoad)="lazyLoad($event)"
    [includeExportCSV]="false"
    (changeViewEvent)="changeViewEvent($event)"
    [scrollHeight]="scrollHeight"
    [usePaginator]="true"
    [rowsPerPageOptions]="[50, 100, 200]"
    #grid
  />
</div>
